import React from 'react';
import { Link } from 'react-router-dom';
import { faSliders } from '@fortawesome/pro-solid-svg-icons';

import { Card, CardBody } from 'reactstrap';
import { PanelHeader, Icon, AsyncDisplay, LoadingMessage } from 'js/components';
import RubricListItem from './RubricListItem';

import styles from './RubricList.module.scss';

function RubricsListComponent({
  workspaceId,
  rows = [],
  loaded,
  error = null,
}) {
  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <div className="content-fluid">
            <div className="row">
              <div className="col-12 col-md-9">
                <h1>Rubrics</h1>
                <p>Aggregate scores across assessment templates</p>
              </div>
              <div className="panel-actions col-12 col-md-3">
                <Link
                  className="btn btn-primary create-link"
                  to={`/w/${workspaceId}/rubrics/new`}
                >
                  <Icon icon="plus" className="btn-icon-left" /> Create
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid" />
      </PanelHeader>

      <div className="content">
        <Card>
          <CardBody>
            <AsyncDisplay isLoading={!loaded} isError={!!error}>
              <AsyncDisplay.Loading>
                <LoadingMessage iconSize="2x">
                  Loading rubrics&hellip;
                </LoadingMessage>
              </AsyncDisplay.Loading>
              <AsyncDisplay.Error>
                <p className="text-danger mb-0">
                  Unable to load rubrics for this workspace.
                </p>
              </AsyncDisplay.Error>
              <AsyncDisplay.Resolved>
                {rows.length > 0 ? (
                  <div className={styles['rubrics-list']}>
                    {rows.map((r) => (
                      <RubricListItem
                        workspaceId={workspaceId}
                        key={r.id}
                        rubric={r}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="media text-muted mt-4 mb-4">
                    <Icon
                      icon={faSliders}
                      size="4x"
                      className="mr-3"
                      fixedWidth
                    />
                    <div className="media-body">
                      <p>You haven't created any rubrics yet.</p>
                      <p className="mb-0">
                        <Link to={`/w/${workspaceId}/rubrics/new`}>
                          Create a rubric
                        </Link>{' '}
                        to get started, then open it here to view scores by
                        team.
                      </p>
                    </div>
                  </div>
                )}
              </AsyncDisplay.Resolved>
            </AsyncDisplay>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default RubricsListComponent;
